export default class PathwayDegreeCourseModel {
  constructor(pathwayCourseInfo) {
    this._courseId = pathwayCourseInfo.courseId;
    this._courseName = pathwayCourseInfo.courseName;
    this._coursePrefix = pathwayCourseInfo.coursePrefix;
    this._courseDescription = pathwayCourseInfo.courseDescription;
    this._courseIsActive = pathwayCourseInfo.courseIsActive;
    this._courseSubject = pathwayCourseInfo.courseSubject;
    this._courseTooltip = pathwayCourseInfo.courseTooltip;
    this._creditHours = pathwayCourseInfo.creditHours;
    this._courseLogo = pathwayCourseInfo.courseLogo;
    this._asuCredits = +pathwayCourseInfo.asuCredits;
    this._extendedDescription = pathwayCourseInfo.courseExtendedDescription;
    this._isCourseSelected = pathwayCourseInfo.isSelected || false;
    this._isSelected = pathwayCourseInfo.isSelected || false;
    this._pathwayRequirement = pathwayCourseInfo.pathwayRequirement;
    this._courseOfferingData = [];
  }
}
